import { Component, OnInit, TemplateRef, ViewChild, AfterViewInit } from '@angular/core';

import { ReportService } from '../../../../common/services/Report.service';
import { moment } from 'ngx-bootstrap/chronos/test/chain';
import { TicketService } from '../../../../common/services/Ticket.service';
import { RoomService } from '../../../../common/services/Room.service';
import { EvsUserService } from '../../../../common/services/EvsUser.service';
import { TicketTypeService } from '../../../../common/services/TicketType.service';
import { ServiceService } from '../../../../common/services/Service.service';
import { PriorityService } from '../../../../common/services/Priority.service';
import { GroupService } from '../../../../common/services/Group.service';
import { UserService } from '../../../../common/services/User.service';
import { ExportService } from '../../../../common/services/Export.service'
import { ToastrService } from 'ngx-toastr';
declare var $: any;
declare var Chartist: any;

@Component({
    selector: 'report-channel',
    templateUrl: "channel.template.html",
    styleUrls: ['./report.component.css'],
    providers: [ReportService,
        TicketService, GroupService, UserService, TicketTypeService, ServiceService, PriorityService, ExportService]
})



export class ChannelComponent implements OnInit {
    public modelFilter: any = {};
    public data: any;
    public data_page_divide: any;
    public channel: any = 'call';
    public exportData: any = [];
    public allSource: any = [{ id: '-1', text: '-- Tất cả --' }, { id: '0', text: 'INBOUND' }, { id: '1', text: 'OUTBOUND' }];
    totalPage: number = 0;
    currentPage: number = 1;
    // public filterType : string  = 'min';

    constructor(
        private reportService: ReportService,
        private ticketService: TicketService,
        private groupService: GroupService,
        private userService: UserService,
        private ticketTypeService: TicketTypeService,
        private serviceService: ServiceService,
        private priorityService: PriorityService,
        private exportService: ExportService,
        private toastr: ToastrService
    ) {
        let user = JSON.parse(localStorage.getItem('User'));
        this.modelFilter = {
            from: moment().add('-30', 'days').format('YYYY-MM-DD HH:mm'),
            to: moment().format('YYYY-MM-DD HH:mm'),
            //source: this.channel
            source: '-1',
            tenantId: user.tenant_id
        }
    }

    ngOnInit() {
        this.loadChannel();
    }


    changeTime(type) {
        let start: any = moment().format('YYYY-MM-DD HH:mm');;
        let end: any = moment().format('YYYY-MM-DD HH:mm');;
        switch (type) {
            case 'year': {
                // start = moment().startOf('year').format('YYYY-MM-DD HH:mm');
                start = moment().add('-365', 'days').format('YYYY-MM-DD HH:mm');
                break;
            }
            case 'month': {
                // start = moment().startOf('month').format('YYYY-MM-DD HH:mm');
                start = moment().add('-30', 'days').format('YYYY-MM-DD HH:mm');
                break;
            }
            case 'week': {
                // start = moment().startOf('isoWeek').format('YYYY-MM-DD HH:mm');
                start = moment().add('-7', 'days').format('YYYY-MM-DD HH:mm');
                break;
            }
            case 'day': {
                // start = moment().startOf('day').format('YYYY-MM-DD HH:mm');
                start = moment().add('-1', 'days').format('YYYY-MM-DD HH:mm');
                break;
            }
            case 'hour': {
                start = moment().add('-1', 'hours').format('YYYY-MM-DD HH:mm');
                break;
            }
            case 'minute': {
                start = moment().add('-30', 'minutes').format('YYYY-MM-DD HH:mm');
                break;
            }
            default: break;
        }
        this.modelFilter['from'] = start;
        this.modelFilter['to'] = end;
        this.loadChannel();
    }

    loadChannel() {
        this.reportService.reportChannel(this.modelFilter).subscribe(res => {
            if (res.data) {
                this.data = res.data;
            } else {
                this.data = [{
                    date: null,
                    source: 0,
                    totalCalls: 0,
                    totalMissCalls: 0,
                    totalAnswerCalls: 0,
                    avgSpeedAnswer: 0,
                    avgAcdTime: 0,
                    avgDuration: 0,
                    avgHoldTime: 0,
                    avgWaitingTime: 0,
                    totalAcdTime: 0,
                    missRatio: 0,
                    slaRatio: 0,
                    slaRatio20: 0,
                }]
            }
            this.totalPage = this.data.length % 10 != 0 ? Math.floor(this.data.length / 10) + 1 : Math.floor(this.data.length / 10);
            var begin = (this.currentPage - 1) * 10;
            var end = this.currentPage * 10;
            this.data_page_divide = this.data.slice(begin, end);
        })
    }

    submitFilter() {
        if (this.modelFilter.from) this.modelFilter.from = moment(this.modelFilter.from).format('YYYY-MM-DD HH:mm');
        if (this.modelFilter.to) this.modelFilter.to = moment(this.modelFilter.to).format('YYYY-MM-DD HH:mm');
        this.loadChannel();
    }

    changeTab(params: any) {
        if (params != this.channel) {
            this.channel = params;
            this.modelFilter['source'] = params;
            this.loadChannel();
        }
    }
    public changedSource(e: any): void {
        if (e.value) {
            this.modelFilter['source'] = e.value;
        } else {
            // multiselect
            //this.modelFilter['source'] = [];
        }
    }

    export() {
        this.exportData = [];
        this.data.forEach(data => {
            this.exportData.push({
                'Ngày': data.date,
                'Kênh': data.source,
                'Tổng số cuộc': data.totalCalls,
                'Tổng số cuộc trả lời': data.totalAnswerCalls,
                'Tổng số cuộc nhỡ': data.totalMissCalls,
                'Tốc độ trả lời TB (s)': data.avgSpeedAnswer,
                // 'Thời gian trả lời TB' : data.avgAcdTime,
                'Thời gian cuộc gọi TB (s)': data.avgDuration,
                'Thời gian hold TB (s)': data.avgHoldTime,
                // 'Tổng thời gian trả lời' : data.totalAcdTime,
                'Tổng thời gian cuộc gọi (s)': data.totalDuration,
                'Tỉ lệ cuộc nhỡ (%)': data.missRatio,
                'SLA': data.slaRatio,
                'SLA (20s)': data.slaRatio20,
            });
        })
        this.exportService.exportExcel(this.exportData, 'Báo cáo hoạt động đa kênh ' + moment(new Date()).format("YYYY-MM-DD HH-mm"));
    }

    setPage(page: number) {
        if (page <= this.totalPage) {
            if (page < 1) {
                page = 1;
            }
            if (page != this.currentPage) {
                this.currentPage = page;
                this.loadChannel();
            }
        }
        else {

            page = this.totalPage;
            $('#inputPage').val(page);
            this.toastr.warning('Số trang tối đa hiện tại là ' + page, '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right'
            });
            if (page <= this.totalPage) {
                //this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
                if (page < 1) {
                    page = 1;
                }
                if (page != this.currentPage) {
                    this.currentPage = page;
                    this.loadChannel();
                }
            }
        }
    }
    goPage2(toPage: any) {
        toPage = parseInt(toPage);
        if (toPage && toPage > 0) {
            this.setPage(toPage);
        }
    }

}



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/pages/admin/icontact/report/channel.component.ts